/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
// utils
// material
import EmojiPreview from 'material/emojipreview/emojipreview'
// content
import PreviewConfig from 'material/previewconfig/previewconfig'
// styles
import injectSheet from 'react-jss'
import styles from './themepreview_styles'
import { themePreview } from 'utils/consts/language'

const orderedEmojis = ['LIKE', 'DISLIKE', 'LOVE', 'FUNNY', 'SAD', 'ANGRY', 'SHOCKED', 'THOUGHTFUL']

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : THEME PREVIEW ~~~~~~~~~~ ========== */
const ThemePreview = injectSheet(styles)((props) => {

  const {  emojiConfigs: emojis, displayConfig, generalConfig } = useSelector(state => state.articleSentimentV2.tempArticleSentimentConfig)

  const emojiCategoryType = emojis && emojis.length ? emojis[0].style : 'THREE_D'

  const mappedEmojis = useMemo(() => emojis && emojis.length ? orderedEmojis.map(orderedEmoji => {
    return emojis.filter(emoji => emoji.name === orderedEmoji)?.pop()
}) : [], [emojis])

  const emojiList = emojis && emojis.length ? mappedEmojis.filter(emoji => emoji.isActive).map((emoji, index) => {
    if(emoji) {
      const emojiName = emoji.name
      return emojiName
    }
  }) : []
  
  const themePreviewLanguage = themePreview[displayConfig.language || 'EN']

  return (
    <div className={`themepreview ${props.classes.themepreview} isemojimonochrome-${emojiCategoryType === 'MONOCHROME' || emojiCategoryType === 'SKELETON'}`}>
      <PreviewConfig title={'Theme Preview'}>
        <EmojiPreview 
          emojis={emojiList} 
          emojiType={emojiCategoryType} 
          showEmojiReactionCount 
          emojiReactionTotal={'1.2k'} 
          headline={generalConfig.headline} 
          totalReactionsLabel={themePreviewLanguage.totalReactions}
        />
      </PreviewConfig>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ThemePreview